<div class="border rounded-xl p-4">
    <app-sub-section-header [text]="agreement.name">
        <ng-container buttons>
            <button *ngIf="!editMode" (click)="edit()">
                <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
            </button>
            <!-- TODO: commented out until delete endpoint exists -->
            <!-- <button *ngIf="!editMode" class="btn btn-error" (click)="deleteAgreement()">
                <iota-icon icon="trash"></iota-icon>
            </button>-->
            <button *ngIf="editMode" class="btn btn-accent" (click)="saveAgreement()">
                <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
            </button>
            <button *ngIf="editMode" class="btn btn-accent" (click)="resetValues()">
                <iota-icon icon="x-mark"></iota-icon>
            </button>
        </ng-container>
    </app-sub-section-header>

    <div [formGroup]="form">
        <div class="grid grid-cols-3 justify-start items-start gap-2">
            <label i18n>Name:</label>
            <input type="text" class="col-span-2 input input-bordered" formControlName="name" />

            <label i18n>Comment:</label>
            <textarea
                class="col-span-2 textarea textarea-bordered"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="20"
                formControlName="comment"
            ></textarea>

            <div class="form-control">
                <label class="label">
                    <span class="label-text" i18n>VersionFrom</span>
                </label>
                <div class="flex flex-row items-center">
                    <input type="date" class="input input-bordered" formControlName="versionFrom" />
                </div>
            </div>

            <div class="form-control">
                <label class="label">
                    <span class="label-text" i18n>VersionTo</span>
                </label>
                <div class="flex flex-row items-center">
                    <input type="date" class="input input-bordered" formControlName="versionTo" />
                </div>
            </div>

            <button class="btn self-end" (click)="resetVersionTo()" [disabled]="!editMode" i18n>Reset VersionTo</button>
        </div>
    </div>
</div>
